var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"sponsored-by",class:_vm.classes,attrs:{"href":_vm.sponsorLink,"target":"_blank"}},[_c('span',{staticClass:"sponsored-by-text"},[_vm._v(_vm._s(_vm.sponsoredByText))]),_c('img',{attrs:{"src":_vm.sponsorURL}})])
}
var staticRenderFns = []

export { render, staticRenderFns }